<template>
	<div class="deliveredies">
		<div class="row justify-content-md-center">
			<div class="col-md-6" v-if="getClientSystem.extras.cpil == true">
				<div class="card rounded-0 mb-2">
					<div class="card-body">
						<div class="form-floating mb-3">
							<input type="search" class="form-control" id="searchClientSendto" placeholder="ej: Juan Perez" v-model="searchClientSendto">
							<label for="searchClientSendto">Escriba el nombre</label>
						</div>
						<div class="table-responsive">
							<table class="table table-sm table-hover">
								<thead>
									<tr class="text-center">
										<th>Nombre</th>
										<th>Telefono</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listClientSendtos" :key="index" class="pointer" @click="searchClientSendto = item.sendto">
										<td>{{item.sendto}}</td>
										<td class="text-center">{{item.phone}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6" v-if="listClientSendtos.length == 1">
				<div class="card rounded-0 mb-2">
					<div class="card-body">
						<h5 class="h5 text-center">Ordenes pendiente de entrega</h5>
						<div class="table-responsive">
							<table class="table table-sm table-hover">
								<thead>
									<tr class="text-center">
										<th :colspan="(listOrderClientSendtoSelected.length > 1) ? 2 : 1">ID</th>
										<th>Fecha Actualización</th>
										<th>Estado</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listOrderClientSendtoSelected" :key="index">
										<td v-if="listOrderClientSendtoSelected.length > 1">
											<svg class="text-black-50 me-1 pointer" width="14" height="14" title="" v-if="item.status_id != 36" @click="item.exists = !item.exists">
												<use xlink:href="#square" v-if="item.exists == 0"/>
												<use xlink:href="#check-square" v-else/>
											</svg>
										</td>
										<td class="text-center">{{ item.id }}</td>
										<td class="text-center">{{ item.updated_at }}</td>
										<td class="text-center">
											<span :class="'badge text-bg-' + item.color">{{ item.status }}</span>
										</td>
										<td class="text-end">
											<svg class="text-info pointer" width="12" height="12" title="Seguimiento" @click="showOrderTrakingsOrderModal(item)"><use xlink:href="#info-circle"/></svg>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="text-end" v-if="getClientSystem.extras.cpil == true">
							<button class="btn btn-sm btn-warning float-start" :disabled="!(listOrderClientSendtoSelectedSelected.length == 1)" @click="showOrderObservationModal(17)">Entregar Parcial</button>
							<button class="btn btn-sm btn-success" :disabled="!(listOrderClientSendtoSelectedSelected.length > 0)" @click="showOrderObservationModal(7)">Entregar</button>
						</div>
						<hr/>
						<h5 class="h5 text-center">Resumen de productos</h5>
						<div class="table-responsive">
							<table class="table table-sm table-hover">
								<thead>
									<tr>
										<th></th>
										<th></th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listProductOrderClientSendtoSelected" :key="index">
										<td>{{item.order_id}}</td>
										<td>{{item.product}}</td>
										<td>{{item.quantity}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Button orderTrakingsOrderModal modal -->
		<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#orderTrakingsOrderModal" ref="btnShowOrderTrakingsOrderModal" v-show="false">
			Abrir Modal Seguimiento
		</button>
		<!-- Modal orderTrakingsOrderModal -->
		<div class="modal fade" id="orderTrakingsOrderModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="orderTrakingsOrderModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content" v-if="orderSelected != null">
					<div class="modal-header">
						<h5 class="modal-title" id="orderTrakingsOrderModalLabel">{{orderSelected.type_order.name}} ({{orderSelected.id}})</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="table-responsive">
							<h5 class="h5">Seguimiento</h5>
							<table class="table table-sm table-hover">
								<thead>
									<tr class="text-center">
										<th>Fecha</th>
										<th>Seguimiento</th>
										<th>Observación</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in orderSelected.order_tracking_order" :key="index">
										<td class="text-center">{{item.created}}</td>
										<td>{{item.description}}</td>
										<td>{{item.observation}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<hr v-if="orderSelected.order_observations.length > 0">
						<div class="table-responsive" v-if="orderSelected.order_observations.length > 0">
							<h5 class="h5">Observación</h5>
							<table class="table table-sm table-hover">
								<thead>
									<tr class="text-center">
										<th>Fecha</th>
										<th>Observación</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in orderSelected.order_observations" :key="index">
										<td class="text-center">{{item.created_at}}</td>
										<td>{{item.observation}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>


		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#orderObservationModal" ref="btnShowOrderObservationModal" v-show="false">
			Abrir Modal Observación
		</button>

		<!-- Modal -->
		<div class="modal fade" id="orderObservationModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="orderObservatioLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="orderObservatioLabel">Información de entrega</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="form-floating mb-3">
							<input type="search" class="form-control" id="searchClientSendto" placeholder="ej: Juan Perez" v-model="sendto">
							<label for="searchClientSendto">Escriba el nombre a quien entrega</label>
						</div>
						<div class="form-floating mb-3">
							<input type="search" class="form-control" id="searchClientSendto" placeholder="ej: Juan Perez" v-model="observation">
							<label for="searchClientSendto">Escriba alguna observación (opcional)</label>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal" ref="btnCloseOrderObservationModal">Cerrar</button>
						<button type="button" class="btn btn-primary btn-sm" @click="deliveredOrders(trackingOrderId)">Continuar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'

	export default {
		name: 'Deliveries',
		mixins: [mixin, axiosAWN],
		data() {
			return {
				onlyPending: 0,
				listOrders: [],
				searchClientSendto: '',
				trackingsOrder: [
					{id: 7, name: 'Entregado', status_id: 36, color: 'success' },
					{id: 17, name: 'Entregado Parcialmente', status_id: 62, color: 'warning' },
				],
				trackingOrderId: 0,
				orderSelected: null,
				observation: '',
				sendto: ''
			}
		},
		computed: {
			listClientSendtos() {
				let list = []
				this.listOrders.forEach(element => {
					let index = list.map((el) => parseInt(el.id)).indexOf(parseInt(element.client_sendto_id))
					if(index == -1 && element.client_sendto_id != null) {
						list.push(element.client_sendto)
					}
				});

				list.sort((a, b) => a.sendto.localeCompare(b.sendto))

				return list.filter(c => c.sendto.toLowerCase().indexOf(this.searchClientSendto.toLowerCase()) > -1)
			},
			listOrderClientSendtoSelected() {
				let list = []
				if(this.listClientSendtos.length == 1) {
					list = this.listOrders.filter((el) => parseInt(el.client_sendto_id) == parseInt(this.listClientSendtos[0].id) )
				}
				return list
			},
			listProductOrderClientSendtoSelected() {
				let listProductos = []
					this.listOrderClientSendtoSelected.forEach(element => {
						if(element.exists == true && element.status_id != 36) {
							element.order_products.forEach(el => {
								let orderProduct = {
										id: el.id,
										order_id: el.order_id,
										product_id: el.product_id,
										product: el.product,
										quantity: el.quantity,
										price: el.price,
										original_price: el.original_price,
										tax: el.tax,
										price_list_id: el.price_list_id,
										created_at: el.created_at,
										updated_at: el.updated_at,
									}
								listProductos.push(orderProduct)
							});
						}
					});
				return listProductos
			},
			listOrderClientSendtoSelectedSelected() {
				let list = []
					list = this.listOrderClientSendtoSelected.filter((el) => el.exists == true && (parseInt(el.status_id) == 56 || parseInt(el.status_id) == 62))
				return list
			}
		},
		methods: {
			initModuleLocal() {
				document.title = 'Entregas - Suscripción ACES Chile'
				this.getAllSubscriptionShippingDetails()
			},
			getAllSubscriptionShippingDetails() {
				this.searchingSubscription = true
				let url = this.getApiBackend + 'subscription/details/church'
				let data = {
						onlyPending: this.onlyPending
					}
				let message = (this.onlyPending) ? 'Pendientes' : 'Todos'
				document.title = 'Buscando detalles de entrega (' + message + ')'
				this.axiosAWNasyncBlock(document.title, 'POST', url, 'getAllSubscriptionShippingDetailsResult', data)
			},
			getAllSubscriptionShippingDetailsResult(response) {
				document.title = 'Entregas - Suscripción ACES Chile'
				if(response.data.success == true) {
					this.listOrders = response.data.data
				} else {
					this.getAllSubscriptionShippingDetailsResultError(response)
				}
			},
			getAllSubscriptionShippingDetailsResultError(error) {
				document.title = 'Error Entregas - Suscripción ACES Chile'
				this.$awn.alert('No se pudo recuperar los detalles de entrega')
				console.log(error)
			},
			showOrderObservationModal(trackingOrderId) {
				this.trackingOrderId = trackingOrderId
				this.observation = ''
				this.sendto = this.listClientSendtos[0].sendto
				this.$refs.btnShowOrderObservationModal.click()
			},
			deliveredOrders(trackingOrderId) {
					let tokens = []
					this.listOrderClientSendtoSelectedSelected.forEach((el) => {
						if(parseInt(el.status_id) == 56 || parseInt(el.status_id) == 62) {
							tokens.push(el.token)
						}
					})
					
					let trackingOrder = this.trackingsOrder.filter((el) => {
								return (el.id == trackingOrderId)
							})
					if(trackingOrder.length != 1) {
						this.$awn.alert('No se puede determinar el seguimiento')
						return
					}
					if(tokens.length == 0) {
						this.$awn.alert('No hay ordenes seleccionadas')
						return
					}
					let onOk = () => { this.updateStatusOrderLocal(tokens, trackingOrderId, 'Entregado a ' + this.sendto, this.observation) };

					this.$awn.confirm('Se cambiara(n) ' + tokens.length + ' orden(es) al estado ' + trackingOrder[0].name + ' <br> ¿Quiere Continuar?', onOk)
			},
			showOrderTrakingsOrderModal(order) {
				this.orderSelected = order
				this.$refs.btnShowOrderTrakingsOrderModal.click()
			},
			updateStatusOrderLocal(tokens, trackingOrderId, observationTracking, observation) {
				let url = this.getApiBackend + 'subscription/details/deliver'
				let data = {
						tokens: tokens,
						trackingOrderId: trackingOrderId,
						observationTracking: observationTracking,
						observation: observation
					}
				document.title = 'Cambiando el estado de la(s) Orden(es)'
				this.axiosAWNasyncBlock(document.title, 'POST', url, 'updateStatusOrderLocalResult', data)
			},
			updateStatusOrderLocalResult(response) {
				document.title = 'Entregas - Suscripción ACES Chile'
				if(response.data.success == true) {
					let ordersTrakingOrder = response.data.data.orderTrackingOrders
					let orderObservations = response.data.data.orderObservations
					ordersTrakingOrder.forEach(element => {
						let index = this.listOrders.map(el => parseInt(el.id)).indexOf(parseInt(element.order_id))
						if(index > -1) {
							this.listOrders[index].status = element.statu.name
							this.listOrders[index].color = element.statu.color
							this.listOrders[index].status_id = element.statu.id
							this.listOrders[index].updated_at = element.updated_at
							this.listOrders[index].order_tracking_order.push(element)
						}
					});
					orderObservations.forEach(element => {
						let index = this.listOrders.map(el => parseInt(el.id)).indexOf(parseInt(element.order_id))
						if(index > -1) {
							this.listOrders[index].order_observations.push(element)
						}
					});
					this.$refs.btnCloseOrderObservationModal.click()
				} else {
					this.updateStatusOrderLocalResultError(response)
				}
			},
			updateStatusOrderLocalResultError(error) {
				this.$awn.alert('No se pudo actualizar el estado ')
				console.log(error)
			}
		},
		mounted () {
			this.initModule()
		}
	}
</script>